import { render, staticRenderFns } from "./faceFirst.vue?vue&type=template&id=5e2187ea&scoped=true"
import script from "./faceFirst.vue?vue&type=script&lang=js"
export * from "./faceFirst.vue?vue&type=script&lang=js"
import style0 from "./faceFirst.vue?vue&type=style&index=0&id=5e2187ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2187ea",
  null
  
)

export default component.exports